export interface RouteItem {
    id: string;
    label: string;
    path: string;
}

const routes: RouteItem[] = [
    { id: 'alpha-perceptron-about', label: 'About', path: '' },
    { id: 'alpha-perceptron-products', label: 'Products', path: '' },
    { id: 'alpha-perceptron-research', label: 'Research', path: '' },
    { id: 'alpha-perceptron-careers', label: 'Careers', path: '' },
    { id: 'alpha-perceptron-blogs', label: 'Blog', path: '' }
];

const otherRoutes: RouteItem[] = [
    { id: 'alpha-perceptron-homepage', label: 'Home', path: ''}
]

export { routes, otherRoutes };
